import Guestline from "@/hotel_integration_modules/bookingEngines/Guestline/Guestline";

declare global {
  interface Window {
    gb_hotel_pid: any;
  }
}

// This is where we'll inject widget as well as handle all other messaging
(() => {
  // Check hotel's PID and inject only if it matches up with the hotels ID found within the url
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const urlHotel = urlParams.get("hotel");
  const urlHotelId = urlParams.get("hotelId");

  if (
    Guestline.injectIntegration &&
    (urlHotel === window.gb_hotel_pid ||
      urlHotelId === window.gb_hotel_pid ||
      window.location.href.indexOf("summary") !== -1 ||
      window.location.href.indexOf("confirmation") !== -1 ||
      window.gb_data.widget.identifier === "tradeshow")
  ) {
    Guestline.injectIntegration();
  }
})();
